<script setup lang="ts">
import { computed } from 'vue';

/** The one button. `loading` implies disabled so a double submit is impossible. */

const props = withDefaults(
  defineProps<{
    variant?: 'default' | 'primary' | 'danger' | 'ghost';
    size?: 'md' | 'sm';
    loading?: boolean;
    disabled?: boolean;
    type?: 'button' | 'submit';
    block?: boolean;
    title?: string;
  }>(),
  {
    variant: 'default',
    size: 'md',
    loading: false,
    disabled: false,
    type: 'button',
    block: false,
    title: undefined,
  },
);

const classes = computed(() => [
  'btn',
  props.variant === 'primary' ? 'btn-primary' : '',
  props.variant === 'danger' ? 'btn-danger' : '',
  props.variant === 'ghost' ? 'btn-ghost' : '',
  props.size === 'sm' ? 'btn-sm' : '',
  props.block ? 'btn-block' : '',
]);
</script>

<template>
  <button :type="type" :class="classes" :disabled="disabled || loading" :title="title">
    <span v-if="loading" class="spinner" aria-hidden="true" />
    <slot />
  </button>
</template>

<style scoped>
.spinner {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: spin 700ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
